/* global window document */

import URLQueryBuilder from 'url-query-builder';

export const RestComponent = {
	props: {},
	data: () => ({}),
	methods: {
		updateUrl(name, value) {
			// let newUrlParams = {};
			// newUrlParams[name] = value;
			// const urlParams = Object.assign({}, newUrlParams);
			// const q = new URLQueryBuilder(document.location.href, urlParams);
			// window.history.replaceState(null, null, q.get());

			const url = new URL(document.location.href);
			const params = new URLSearchParams(url.search);

			params.set(name, value);

			if (value.length === 0 || value === null) {
				params.delete(name);
			}

			window.history.replaceState(null, null, `${location.pathname}?${params}`);
		},
		getUrlVars() {
			let vars = [], hash;
			const hashes = window.location.search.slice(window.location.search.indexOf('?') + 1).split('&');
			for (let i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		getAllUrlParams(url) {
			// get query string from url (optional) or window
			let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

			// we'll store the parameters here
			let obj = {};

			// if query string exists
			if (queryString) {

				// stuff after # is not part of query string, so get rid of it
				queryString = queryString.split('#')[0];

				// split our query string into its component parts
				let arr = queryString.split('&');

				for (let i = 0; i < arr.length; i++) {
					// separate the keys and the values
					let a = arr[i].split('=');

					// in case params look like: list[]=thing1&list[]=thing2
					let paramNum = undefined;
					let paramName = a[0].replace(/\[\d*\]/, function (v) {
						paramNum = v.slice(1, -1);
						return '';
					});

					// set parameter value (use 'true' if empty)
					let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

					// (optional) keep case consistent
					paramName = paramName.toLowerCase();
					paramValue = paramValue.toLowerCase();

					// if parameter name already exists
					if (obj[paramName]) {
						// convert value to array (if still string)
						if (typeof obj[paramName] === 'string') {
							obj[paramName] = [obj[paramName]];
						}
						// if no array index number specified...
						if (typeof paramNum === 'undefined') {
							// put the value on the end of the array
							obj[paramName].push(paramValue);
						}
						// if array index number specified...
						else {
							// put the value at that index number
							obj[paramName][paramNum] = paramValue;
						}
					}
					// if param name doesn't exist yet, set it
					else {
						obj[paramName] = paramValue;
					}
				}
			}

			return obj;
		},
	},
};




